import { NavLink } from "react-router-dom";
import { useSiteData } from "../../app/SiteDataContext";

function Footer() {
  const { navigation, settings } = useSiteData();
  const siteProfile = settings.siteProfile;
  const socialLinks = settings.socialLinks || [];
  const footer = settings.footer || {
    heading: "Temiz mimari, premium deneyim ve guclu dijital algi.",
    copy:
      "Kisisel marka siteleri, urun vitrinleri ve icerik odakli deneyimler icin tasarim ile muhendisligi tek cizgide bulusturuyorum.",
  };

  return (
    <footer className="site-footer">
      <div className="glass-panel footer-grid">
        <div className="footer-brand">
          <p className="eyebrow">Built for lasting brand value</p>
          <h2>{footer.heading}</h2>
          <p className="section-copy">{footer.copy}</p>
        </div>

        <div className="footer-column">
          <h3>Gezinme</h3>
          {navigation.map((item) => (
            <NavLink key={item.path} to={item.path} className="footer-link">
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="footer-column">
          <h3>Baglanti</h3>
          <a className="footer-link" href={`mailto:${siteProfile.email}`}>
            {siteProfile.email}
          </a>
          {socialLinks.map((item) => (
            <a
              key={item.label}
              className="footer-link"
              href={item.href}
              target="_blank"
              rel="noreferrer"
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
